const sizePalette = (tokens) => {
    return {
        width: {
            column: {
                column1: tokens.aliasesSizeWidthColumn1,
                column2: tokens.aliasesSizeWidthColumn2,
                column3: tokens.aliasesSizeWidthColumn3,
                column4: tokens.aliasesSizeWidthColumn4,
                column6: tokens.aliasesSizeWidthColumn6,
                column8: tokens.aliasesSizeWidthColumn8
            },
            desktop: {
                default: tokens.aliasesSizeWidthDesktopDefault
            }
        },
        height: {
            input: {
                dense: tokens.aliasesSizeHeightInputDense
            },
            desktop: {
                default: tokens.aliasesSizeHeightDesktopDefault
            }
        },
        component: {
            xxlarge: tokens.aliasesSizeComponentXxl,
            xlarge: tokens.aliasesSizeComponentXl,
            medium: tokens.aliasesSizeComponentM
        }
    };
};
export default sizePalette;
//# sourceMappingURL=size.js.map